import React from 'react';
import {
  FaBriefcase,
  FaCloud,
  FaCode,
  FaDatabase,
  FaDesktop,
  FaServer,
  FaTerminal,
} from 'react-icons/fa';

const icons = {
  Server: FaServer,
  Cloud: FaCloud,
  Layout: FaDesktop,
  Database: FaDatabase,
  Terminal: FaTerminal,
  Briefcase: FaBriefcase,
  Code: FaCode,
};

function Skills({ skillGroups }) {
  return (
    <section className="portfolioSection sectionReveal" id="skills">
      <div className="portfolioSection__heading">
        <span className="portfolioEyebrow">Skills</span>
        <h2>Technology Ecosystem</h2>
        <p>Frontend, backend, databases, cloud, and integration tools connected into one full-stack delivery system.</p>
      </div>

      <div className="portfolioTechEcosystem">
        <div className="portfolioTechCore" aria-hidden="true">
          <span>Full-Stack</span>
          <strong>Development</strong>
        </div>
        {skillGroups.map((group) => {
          const Icon = icons[group.icon] || FaCode;
          return (
            <article className="portfolioSkillCard" key={group.title}>
              <div className="portfolioSkillCard__icon"><Icon /></div>
              <h3>{group.title}</h3>
              <div className="portfolioTags portfolioTags--small">
                {group.skills.map((skill) => <span key={skill}>{skill}</span>)}
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}

export default Skills;
